<template>
  <div class="page-about">    
    <RefChapter1 />
    <RefChapter2 />
    <RefChapter3 />
    <ScrollTopBtn />
  </div>
</template>

<script>
import RefChapter1 from '@/components/views/references/RefChapter1'
import RefChapter2 from '@/components/views/references/RefChapter2'
import RefChapter3 from '@/components/views/references/RefChapter3'
import ScrollTopBtn from '@/components/layout/ScrollTopButton'

export default {
  name: 'AboutPage',
  components: {
    RefChapter1,
    RefChapter2,
    RefChapter3,
    ScrollTopBtn
  },
  data() {
    return {
    };
  },
  methods: {},
}
</script>